import { createContext, useContext } from 'react';

var noop = function noop() {};

export var SkipLinksContext = /*#__PURE__*/createContext({
  skipLinksData: [],
  registerSkipLink: noop,
  unregisterSkipLink: noop
});
export var useSkipLinks = function useSkipLinks() {
  return useContext(SkipLinksContext);
};